import * as React from "react";

/**
 * A simple wrapper component for displaying a list of comments.
 * This is just a presentational container - the parent controls what gets rendered inside.
 */
export function CommentList({ children }: React.PropsWithChildren) {
  return <div>{children}</div>;
}
